import React, { useEffect } from 'react';
import {useHistory, useLocation} from 'react-router-dom';

const ProfileConnectRedirect = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        (async () => {
            const params = new URLSearchParams(location.search);
            const profileConnectSessionId = params.get('sessionId');
            const routeName = localStorage.getItem('profileConnectRedirectTo');
            sessionStorage.setItem('profileConnectSessionId', profileConnectSessionId ?? '');
            if (routeName) {
                sessionStorage.setItem('hasRedirectedToProfileConnect', String(true));
                console.log(`Performing profile connect redirect to ${routeName}`);
                history.replace(routeName);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div>Profile Connect...</div>;
};

export default ProfileConnectRedirect;
